import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/guestadd/:id',
      name: 'guestadd',
      component: () => import('@/views/guest/guestAdd.vue'),
      props: true,
      meta: { title: '来访登记' },
    },
	  {
      path: '/smsConfirm/:token',
      name: 'smsConfirm',
      component: () => import('@/views/guest/smsConfirm.vue'),
      props: true,
      meta: { title: '来访登记' },
    },
  ],
})

export default router

router.beforeEach((to, from, next) => {
  const path = to.name
  const pathArr = ['home', 'about']
  if (pathArr.includes(path)) {
    store.commit('increment')
  } else {
    store.commit('incrementOn')
  }
  next()
})
